// extracted by mini-css-extract-plugin
export default {"root":"search_root__O7l-q","input":"search_input__Y9tYd","img":"search_img__4TEGg","deletet":"search_deletet__711HO"};